import React from 'react';
import { removeUser, addUser } from 'actions/actions';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import routes from 'library/Routes';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { serviceLocator } from './ServiceLocator';

export const WLWrapper = (DefaultComponent, WLComponents) => {
  class WLWrapper extends React.Component {
    state = { allowed: false };

    render() {
      const clientCabinet = this.props.domain?.owner?.organizationSettings?.clientCabinet;

      if (WLComponents[clientCabinet]) {
        const WLComponent = WLComponents[clientCabinet];

        return <WLComponent {...this.props} />;
      }

      return <DefaultComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    const translate = getTranslate(state.locale);
    const currentLanguage = getActiveLanguage(state.locale).code;
    const domain = state.domain;

    return {
      user: state.user,
      t: translate,
      domain,
      currentLanguage,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      addUser: function (user) {
        dispatch(addUser(user));
      },
      logOff: (location) => {
        let api = serviceLocator.userApi;
        api.killSession();
        dispatch(removeUser());
        if (location) {
          dispatch(push(`${routes.login()}?path=${location.pathname}${location.search}`));
        } else {
          dispatch(push(`${routes.login()}`));
        }
      },
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(WLWrapper);
};
